import axios from 'axios';
import i18n from 'i18next';
import createI18nextFetchBackend from 'i18next-fetch-backend';
import { identity, isPlainObject, isString } from 'lodash-es';
import { initReactI18next } from 'react-i18next';

import logger from './logger';

i18n
  .use(createI18nextFetchBackend)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    react: {
      useSuspense: false,
    },

    fallbackLng: 'en',
    backend: {
      loadPath: `${process.env.PUBLIC_URL}/lang/{{lng}}.json`,
      parse: identity,
      allowMultiLoading: false,
      fetch: (url) =>
        axios.get(url).then(({ status, data }) => ({ status, ok: status >= 200 && status < 300, text: () => data })),
    },

    keySeparator: '.', // we do not use keys in form messages.welcome

    saveMissing: true,
    missingKeyHandler: (lng, ns, key) => {
      logger.warn(`Translation key is missing! [key='${key}', lng='${lng}', ns='${ns}'}]`);
    },

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

// to make translation key more flexible we override the original t(...) method to a new one
// supporting a key-as-bject with already translated messages (translated) and
// accepting the key and params in a single object.
const originalTranslator = i18n.t;
i18n.t = (keyOrObj, options) => {
  if (isPlainObject(keyOrObj)) {
    const { key, translated, ...opts } = keyOrObj;
    // in case 'translated' prop is set we can simply return it (eg. server-side text error)
    return isString(translated) ? translated : originalTranslator.call(i18n, key, { ...opts, ...options });
  }

  return originalTranslator.call(i18n, keyOrObj, options);
};
